/**
 * Typeahead action. (item 3)
 *
 * Goes through Volto's api middleware rather than a bare `fetch` for one
 * reason that matters: the middleware is what knows the API base. In seamless
 * mode that base is the request origin on the server and the app origin in the
 * browser, and `internalApiPath` replaces it during SSR — a hand-rolled fetch
 * would have to re-derive all of that and would get it wrong somewhere.
 */
export const GET_SUGGESTIONS = 'GET_SUGGESTIONS';

/**
 * @param {string} term    what the user has typed so far
 * @param {object} options `{ scope }` — 'all', or a comma-separated list of
 *                         archive ids; omitted means the current archive
 */
export function getSuggestions(term, { scope } = {}) {
  const params = new URLSearchParams({ q: term });
  if (scope) params.set('scope', scope);
  return {
    type: GET_SUGGESTIONS,
    // The service is registered for the site root, which is what the empty
    // content path resolves to in seamless mode.
    request: { op: 'get', path: `/@suggest?${params.toString()}` },
    // Carried through to the reducer so a slow response for an old prefix
    // cannot overwrite a fast one for a newer prefix.
    term,
  };
}
